import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../global.scss';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import TableLoader from '../TableLoader';
import GlobalFooter from '../GlobalFooter';

function BankEurSelect() {
  const record = JSON.parse(localStorage.getItem('auth'));
  const navigate = useNavigate();
  const location = useLocation();
  const countryCode = localStorage.getItem('countryCode');
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankingType, setBankingType] = useState('PERSONAL'); // Default to Personal
  const [personalBanks, setPersonalBanks] = useState([]);
  const [businessBanks, setBusinessBanks] = useState([]);
  const [isBankListLoading, setIsBankListLoading] = useState(false);

  useEffect(() => {
    getBankList();
  }, []);

  const handleBack = () => {
    navigate('/pages/payment-credential');
  };

  const handleClose = () => {
    navigate('/pages/payment-account');
  };

  const getBankList = async () => {
    setIsBankListLoading(true);
    try {
      const result = {
        countryCode: countryCode,
      };

      const url =
        'https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/europe/institutions';
      const res = await axios.post(url, result);

      const accounts = res.data.data;

      setIsBankListLoading(false);

      // Separate personal and business banks
      setPersonalBanks(accounts.personalBanks || []);
      setBusinessBanks(accounts.businessBanks || []);
    } catch (err) {
      setIsBankListLoading(false);
      console.log(err);
      const errorMessage =
        err.response?.data?.message ||
        'An Unexpected error has occured: try again';
      toast.error(errorMessage);
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const selectBank = (bank) => {
    setSelectedBank(bank);
  };

  const handleBankingTypeChange = (type) => {
    setBankingType(type);
  };

  // Filter banks based on search term and selected banking type
  const filteredBanks = (
    bankingType === 'PERSONAL' ? personalBanks : businessBanks
  ).filter((bank) => bank.fullName.toLowerCase().includes(searchTerm));

  const handleSubmit = async () => {
    setIsLoading(true);
    if (!selectedBank) return toast('Please select a bank to proceed');

    const payload = {
      institutionId: selectedBank.id,
      amount: `${record?.data?.amount}`,
      countryCode: countryCode,
      transactionId: `${record?.data?.transactionId}`,
    };
    if (
      countryCode == 'GB' ||
      countryCode == 'IE' ||
      countryCode === 'BE' ||
      countryCode === 'PT' ||
      countryCode === 'ES'
    ) {
      try {
        const url =
          'https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/europe/v2/initiate-payment-auth-others-2';
        const res = await axios.post(url, payload);
        console.log('result: ', res.data);
        const { authorisationUrl } = res.data.data.data;
        setIsLoading(false);
        if (authorisationUrl) {
          setIsLoading(false);
          window.location.href = authorisationUrl;
          return;
        } else {
          toast('External link not available');
          return;
        }
      } catch (err) {
        setIsLoading(false);
        console.log(err);
        const errorMessage =
          err.response?.data?.message ||
          'An Unexpected error has occured: try again';
        toast.error(errorMessage);
      }
    } else {
      setIsLoading(false);
      navigate('/pages/account-identification', { state: { payload } });
    }
  };

  return (
    <div className="global_layout">
      <div className="global_container">
        <div className="top_bar">
          <img
            src="/images/global/arrow-left.svg"
            alt=""
            onClick={handleClose}
          />
          <p className="choose-your-bank">Choose your bank</p>
          <img src="/images/global/close.svg" alt="" onClick={handleClose} />
        </div>

        <div className="select-banks">
          <div className="search-banks">
            <input
              className="search-field"
              type="text"
              placeholder="Search for your bank"
              name="search"
              value={searchTerm}
              onChange={handleInputChange}
            />
            <img src="/images/global/search.svg" alt="search" />
          </div>

          <div className="banking">
            <p
              className={`banking-option ${
                bankingType === 'PERSONAL' ? 'banking-active' : ''
              }`}
              onClick={() => handleBankingTypeChange('PERSONAL')}
            >
              Personal
            </p>
            {businessBanks.length > 0 && (
              <p
                className={`banking-option ${
                  bankingType === 'BUSINESS' ? 'banking-active' : ''
                }`}
                onClick={() => handleBankingTypeChange('BUSINESS')}
              >
                Business
              </p>
            )}
          </div>

          <div className="bank_list">
            {isBankListLoading ? (
              <div className="loading-spinner">
                <BeatLoader color={'#123abc'} loading={isLoading} />
              </div>
            ) : (
              filteredBanks.map((bank, index) => (
                <div
                  className={`select-bank ${
                    selectedBank?.id === bank.id ? 'selected' : ''
                  }`}
                  key={index}
                  onClick={() => selectBank(bank)}
                >
                  <img
                    src={bank.media[0].source}
                    alt="bank"
                    style={{
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                    }}
                  />
                  <p
                    className={`bank-name ${
                      selectedBank?.id === bank.id ? 'selected-text' : ''
                    }`}
                  >
                    {bank.fullName}
                  </p>
                </div>
              ))
            )}
          </div>

          <button
            disabled={!selectedBank || isLoading}
            className={`${
              !selectedBank || isLoading ? 'unactive' : 'globalBtn'
            }`}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '18px',
              gap: '8px',
            }}
            onClick={handleSubmit}
          >
            {isLoading ? (
              <BeatLoader color="#FFF" cssOverride={{}} />
            ) : (
              <>
                <p>Confirm</p>
                {!selectedBank || isLoading ? (
                  <img src="/images/global/inactive.svg" alt="" />
                ) : (
                  <img src="/images/global/activeArrow.svg" alt="" />
                )}
              </>
            )}
          </button>
        </div>
      </div>
      {isBankListLoading && <TableLoader />}
      {!record?.total_whitelabelling && <GlobalFooter />}
    </div>
  );
}

export default BankEurSelect;
